(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-reusable-water-sponge-balls",
      exitUrl: "/pages/9-reasons-why-water-sponge-balls",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "¡Arma el set perfecto para tu familia!",
      trustLine: "Más de 3.500 familias felices con garantía de 90 días",
      fixedKit: {
        name: "Tu configuración de batalla de agua está lista",
        tagline:
          "Ideal para juegos de agua al aire libre supervisados en césped o colchoneta blanda.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "Ahorras \xA320 hoy",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Se verifica tu configuración de batalla de agua",
          "Se añaden 10 esponjas de agua extra gratis",
          "Se añaden 2 bolsas de malla gratis",
          "Garantía de reembolso de 90 días",
        ],
        reviews: [
          {
            text: "¡A mis nietos les encantan! No más restos de globos en el jardín.",
            author: "Sandra M.",
            status: "comprador verificado \u2714",
          },
          {
            text: "La mejor compra de este verano. ¡Mis hijos se pelean por quién las rellena!",
            author: "Jennifer R.",
            status: "comprador verificado \u2714",
          },
          {
            text: "Las usé en el cumpleaños de mi nieto, 15 niños jugando 3 horas. ¡Cero limpieza!",
            author: "Robert K.",
            status: "comprador verificado \u2714",
          },
        ],
      },
      loadingItems: [
        "Se verifica tu configuración de batalla de agua",
        "Se añaden 10 esponjas de agua extra gratis",
        "Se añaden 2 bolsas de malla gratis",
        "Garantía de reembolso de 90 días",
      ],
      steps: [
        {
          id: "who",
          eyebrow: "Pregunta 1 de 5",
          question: "¿Para quién lo compras?",
          subtext: "Esto nos ayuda a confirmar la opción correcta para tu familia.",
          options: [
            {
              value: "My grandkids",
              icon: "\uD83D\uDC75",
              label: "Mis nietos",
              desc: "Mis nietos",
            },
            {
              value: "My own kids",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Mis hijos",
              desc: "Mis hijos",
            },
            {
              value: "For a party or event",
              icon: "\uD83C\uDF89",
              label: "Para una fiesta o evento",
              desc: "Para una fiesta o evento",
            },
            {
              value: "It's a gift",
              icon: "\uD83C\uDF81",
              label: "Es un regalo",
              desc: "Es un regalo",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Pregunta 2 de 5",
          question: "¿Cuántos niños juegan normalmente al mismo tiempo?",
          subtext: "Cuenta a todos los que podrían unirse.",
          options: [
            {
              value: "1-2",
              icon: "👦",
              label: "1–2",
            },
            {
              value: "3-4",
              icon: "👧👦",
              label: "3–4",
            },
            {
              value: "5-6",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "5–6",
            },
            {
              value: "7+",
              icon: "\uD83C\uDF8A",
              label: "7+",
            },
          ],
        },
        {
          id: "surface",
          eyebrow: "Pregunta 3 de 5",
          question: "¿Qué grupos de edad participarán principalmente?",
          subtext: "La superficie influye en qué tan bien se mantiene en su lugar.",
          options: [
            {
              value: "1-4",
              icon: "\uD83E\uDDF8",
              label: "1–4",
            },
            {
              value: "5-8",
              icon: "\uD83D\uDCA6",
              label: "5–8",
            },
            {
              value: "9-12",
              icon: "\uD83C\uDFC3",
              label: "9–12",
            },
            {
              value: "Mixed ages",
              icon: "\uD83C\uDF08",
              label: "Grupos de edad mixtos",
              desc: "Ayúdame a decidir",
            },
          ],
        },
        {
          id: "hose",
          eyebrow: "Pregunta 4 de 5",
          question: "¿Dónde las usarán más?",
          subtext:
            "La alfombrilla de agua se conecta directamente a una manguera de jardín estándar.",
          options: [
            {
              value: "Garden",
              icon: "\uD83C\uDFE1",
              label: "Jardín",
            },
            {
              value: "Pool",
              icon: "\uD83C\uDFCA",
              label: "Piscina",
            },
            {
              value: "Beach",
              icon: "\uD83C\uDFD6\uFE0F",
              label: "Playa",
            },
            {
              value: "A bit of everything",
              icon: "\uD83C\uDF0D",
              label: "Un poco de todo",
            },
          ],
        },
        {
          id: "priority",
          eyebrow: "Pregunta 5 de 5",
          question: "¿Qué es lo más importante para ti?",
          subtext: "Elige la que mejor se adapte.",
          options: [
            {
              value: "No balloon waste to clean up",
              icon: "\uD83E\uDDF9",
              label: "Sin residuos de globos para limpiar",
            },
            {
              value: "Refills in seconds",
              icon: "\uD83D\uDCA7",
              label: "Recarga en segundos",
            },
            {
              value: "Enough for the whole group",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Suficiente para todo el grupo",
            },
            {
              value: "Easy to store",
              icon: "\uD83D\uDC5C",
              label: "Fácil de guardar",
            },
            {
              value: "Good value for parties",
              icon: "\uD83C\uDFF7\uFE0F",
              label: "Buena relación calidad-precio para fiestas",
            },
          ],
        },
        {
          id: "alternative",
          eyebrow: "Pregunta 6 de 6",
          question: "¿Qué prefieres?",
          subtext: "Elige la que mejor se adapte.",
          options: [
            {
              value: "Just enough",
              icon: "\uD83D\uDC66",
              label: "Justo lo necesario",
              desc: "Justo lo necesario",
            },
            {
              value: "A little extra",
              icon: "\u2795",
              label: "Un poco más",
              desc: "Un poco más",
            },
            {
              value: "Cousins and friends",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Suficiente para primos y amigos",
              desc: "Suficiente para primos y amigos",
            },
            {
              value: "Party-ready",
              icon: "\uD83C\uDF89",
              label: "Listo para la fiesta",
              desc: "Listo para la fiesta",
            },
          ],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Solo tarda 1 minuto</div><h1 class="quiz-intro-headline">¡Encuentra el set de batalla de agua perfecto para tu familia!</h1><p class="quiz-intro-sub">Responde 6 preguntas cortas y recibe tu set personalizado de esponjas de agua – <strong>¡más de 10 esponjas extra gratis!</strong></p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> No más recoger trozos de globos</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Recarga en 5 segundos</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> Más de 3.500 reseñas de cinco estrellas de familias</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Encontrar mi set ideal<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Tu set está siendo preparado</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
  function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Atrás</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p><div class="quiz-options">' +
        step.options
          .map(function (o) {
            return optionCard(o, step.id);
          })
          .join("") +
        '</div><div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "Ver mi recomendación" : "Siguiente") +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Tu set recomendado está siendo preparado</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Viendo mi set recomendado \u2026</h2><p class="loading-sub" id="loading-sub">Personalizando según tus respuestas</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub">Hemos encontrado el set de batalla de agua perfecto según tus respuestas.</p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% DESCUENTO</span><span class="kit-ready-btn-text">Ver mi set recomendado \u2192</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Repetir el quiz</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var kit = CONFIG.fixedKit,
          url = CONFIG.productUrl;
        kit.variantId &&
          kit.variantId.indexOf("REPLACE_") !== 0 &&
          (url += "?variant=" + kit.variantId);
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn && ctaBtn.setAttribute("href", url);
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">¡Tu set está listo!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
  function advance() {
    var step = CONFIG.steps[state.currentStep];
    state.answers[step.id] &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 minuto</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
//# sourceMappingURL=/s/files/1/0760/0662/1462/files/Splash_Pad_Quiz.js.map?v=1780486916